module.exports = __webpack_public_path__ + "img/IMAGE07.22e9dc7b.jpg";